import React from 'react';

export default ({ color }) => (
   <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 11 20"><title>icon-arrow-left</title><g id="Layer_2" data-name="Layer 2"><g id="Layer_1-2" data-name="Layer 1"><polyline fill="none" stroke={color} strokeLinecap="round" strokeLinejoin="round" strokeWidth="2px" points="10 19 1 10 10 1"/></g></g></svg>
);
